import Component from '@/components/lazy-mutation-callback';

declare global {
  interface Window {
    LazyMutationCallback: typeof Component;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.LazyMutationCallback = Component;
});
